import { SportsMarketCard } from '@/components';
import { mockSportsMarkets } from '@/data';

type SportsMarketCardItemProps = {
  sportsMarket: (typeof mockSportsMarkets)[0];
  onTradeClick: (marketId: string, teamId: string) => void;
};

const SportsMarketCardItem = ({ sportsMarket, onTradeClick }: SportsMarketCardItemProps) => {
  const teamsTuple = [sportsMarket.teams[0], sportsMarket.teams[1]] as [
    (typeof sportsMarket.teams)[0],
    (typeof sportsMarket.teams)[1],
  ];

  return (
    <SportsMarketCard
      market={{
        ...sportsMarket,
        teams: teamsTuple,
      }}
      onTradeClick={onTradeClick}
    />
  );
};

type SportsMarketCardListProps = {
  onTradeClick: (marketId: string, teamId: string) => void;
};

export const SportsMarketCardList = ({ onTradeClick }: SportsMarketCardListProps) => {
  return (
    <>
      {mockSportsMarkets.map((sportsMarket) => (
        <SportsMarketCardItem
          key={sportsMarket.id}
          sportsMarket={sportsMarket}
          onTradeClick={onTradeClick}
        />
      ))}
    </>
  );
};

export default SportsMarketCardList;
